// extracted by mini-css-extract-plugin
module.exports = {"ConsultantsListSearch":"SearchInput_ConsultantsListSearch__2WPNh"};